import { AssetTypes } from '@api/v4/assets/assetTypes';
import { ModalEditFormContentState, ValidationErrors } from './EditTabTypes';
import { isValidHex } from './helpers';

const validateName = (assetType, { assetName }: ModalEditFormContentState): ValidationErrors[] => {
  if (!assetName && assetType !== AssetTypes.Font) {
    return [ValidationErrors.MissingAssetName];
  }

  return [];
};

const validateDescription = (assetType, { assetDescription }: ModalEditFormContentState): ValidationErrors[] => {
  if (assetType === AssetTypes.Text && !assetDescription) {
    return [ValidationErrors.MissingDescription];
  }

  return [];
};

const validateUrl = (assetType, { externalMediumData }: ModalEditFormContentState): ValidationErrors[] => {
  if (assetType === AssetTypes.ExternalMedium) {
    // TODO: do we want to validate that it's a valid url?
    if (!externalMediumData || !externalMediumData.url) {
      return [ValidationErrors.MissingMediaUrl];
    }
  }

  return [];
};

const validateFontInput = (assetType, { fontData }: ModalEditFormContentState): ValidationErrors[] => {
  if (assetType === AssetTypes.Font) {
    if (!fontData || (!fontData.other_font_id && !fontData.web_font_id)) {
      return [ValidationErrors.MissingFontInput];
    }
  }

  return [];
};

const validateHexInput = (assetType, { colorData }: ModalEditFormContentState): ValidationErrors[] => {
  if (assetType === AssetTypes.Color) {
    if (colorData && colorData.hex) {
      if (!isValidHex(colorData.hex)) {
        return [ValidationErrors.InvalidHexValue];
      }
    }
  }

  return [];
};

const validate = (assetType: AssetTypes, editState: ModalEditFormContentState): ValidationErrors[] => (
  [
    ...validateName(assetType, editState),
    ...validateDescription(assetType, editState),
    ...validateUrl(assetType, editState),
    ...validateFontInput(assetType, editState),
    ...validateHexInput(assetType, editState)
  ]
);

export default validate;
